// Alert to provide notice of cookie usage.

const notice = document.querySelector('.cookie-notice');

setTimeout(() => {
	// Check for the notice and ensure it has not been dismissed.
	if (notice && ! localStorage.getItem('cookie-notice-closed')) {
		// Display notice.
		notice.classList.add('cookie-notice--display');
		// Add class to transition to visible state.
		notice.classList.add('cookie-notice--visible');

		const dismissButton = document.querySelector('.cookie-notice__dismiss');

		// Handle dismissal button.
		dismissButton.addEventListener('click', () => {
			// Remove visible class to start transition to hidden state.
			notice.classList.remove('cookie-notice--visible');
			// Add localStorage to prevent notice from displaying again.
			localStorage.setItem('cookie-notice-closed', true);
			// Wait for transition to end, then remove display class.
			notice.addEventListener('transitionend', () => {
				notice.classList.remove('cookie-notice--display');
			});
		});
	}
}, 10);
